export default function isObject(obj) {
    return obj === Object(obj);
}
//# sourceMappingURL=isObject.js.map